import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <div className="terms-header">
        <div className="container">
          <div className="navigation">
            <a href="/" className="back-button">← Back to Home</a>
          </div>
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
        </div>
      </div>

      <div className="container">
        <div className="terms-section">
          <h2><span className="section-icon">📋</span>Agreement to Terms</h2>
          <p>By accessing and using our landscaping services, you agree to be bound by these Terms of Service of Gardenia Landscaping LLC. If you disagree with any part of these terms, you may not use our services.</p>
        </div>

        <div className="terms-section">
          <h2><span className="section-icon">🌿</span>Service Description</h2>
          <p>We provide professional landscaping services including but not limited to lawn maintenance, garden design, tree care, and hardscaping. Our services are subject to availability and weather conditions.</p>
          
          <div className="terms-list">
            <h3>Our Services Include:</h3>
            <ul>
              <li>Regular lawn maintenance and mowing</li>
              <li>Garden design and installation</li>
              <li>Tree trimming and removal</li>
              <li>Hardscape installation</li>
              <li>Irrigation system installation and maintenance</li>
              <li>Seasonal cleanup and maintenance</li>
            </ul>
          </div>
        </div>

        <div className="terms-section">
          <h2><span className="section-icon">💰</span>Pricing and Payment</h2>
          <p>Pricing for our services is based on the scope of work, property size, and specific requirements. Payment terms are as follows:</p>
          
          <div className="terms-list">
            <h3>Payment Terms:</h3>
            <ul>
              <li>50% deposit required for projects over $1,000</li>
              <li>Payment is due upon completion for regular maintenance</li>
              <li>Accepted payment methods: cash, check, or credit card</li>
              <li>Late payments subject to 1.5% monthly interest</li>
            </ul>
          </div>
        </div>

        <div className="terms-section">
          <h2><span className="section-icon">📅</span>Scheduling and Cancellations</h2>
          <p>We strive to provide reliable and timely service. Our scheduling and cancellation policies are designed to ensure efficient service delivery:</p>
          
          <div className="terms-list">
            <h3>Policies:</h3>
            <ul>
              <li>24-hour notice required for cancellations</li>
              <li>Weather-related rescheduling at no additional charge</li>
              <li>$50 fee for same-day cancellations</li>
              <li>Regular maintenance scheduled on fixed days</li>
            </ul>
          </div>
        </div>

        <div className="terms-section">
          <h2><span className="section-icon">⚠️</span>Liability and Insurance</h2>
          <p>While we maintain comprehensive insurance coverage, certain limitations apply:</p>
          
          <div className="terms-list">
            <h3>Coverage Details:</h3>
            <ul>
              <li>Full liability insurance for property damage</li>
              <li>Workers' compensation for all employees</li>
              <li>Not responsible for pre-existing property conditions</li>
              <li>Client must disclose underground utilities</li>
            </ul>
          </div>
        </div>

        <div className="terms-section">
          <h2><span className="section-icon">🤝</span>Customer Responsibilities</h2>
          <p>To ensure the best possible service, customers must:</p>
          
          <div className="terms-list">
            <h3>Requirements:</h3>
            <ul>
              <li>Provide accurate property information</li>
              <li>Secure pets during service</li>
              <li>Mark or identify sensitive plants or areas</li>
              <li>Maintain clear access to service areas</li>
              <li>Communicate special requirements in advance</li>
            </ul>
          </div>
        </div>

        <div className="terms-section">
          <h2><span className="section-icon">📞</span>Contact Information</h2>
          <p>For questions or concerns about these terms, please contact us:</p>
          <p>
            Gardenia Landscaping LLC<br />
            PO Box 243<br />
            Seville, FL 32190<br />
            Phone: (386) 864-9197<br />
            Email: gardeniallc3@gmail.com<br />
            Hours: Mon-Fri 8AM-6PM, Sat 9AM-4PM
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 